// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const getStoredToken = () => {

    return localStorage.getItem("token");
};


const initialState = {

    isAuthenticated:
        !!getStoredToken(),

    user: null,

    token:
        getStoredToken(),

    loginModalOpen: false,

    pendingAction: null
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginSuccess(state, action) {
            state.isAuthenticated = true;
            state.user = action.payload;
            state.token = action.payload.token;
            state.loginModalOpen = false;
        },

        logout() {
            return initialState;
        },

        openLoginModal(state) {
            state.loginModalOpen = true;
        },

        closeLoginModal(state) {
            state.loginModalOpen = false;
        },

        setPendingAction(state, action) {
            state.pendingAction = action.payload;
        },

        clearPendingAction(state) {
            state.pendingAction = null;
        },
    },
});

export const {
    loginSuccess,
    logout,
    openLoginModal,
    closeLoginModal,
    setPendingAction,
    clearPendingAction,
} = authSlice.actions;

export default authSlice.reducer;
